import isIntuit from "Intuit/isIntuit";

import * as urls from "./urls";

// We only do the "redirect" for Intuit for now.
export const getUrlFromCompanyProfile = ({ borApplication, siteConfig }) => {
  if (siteConfig?.list_source === "Aba") {
    return isSignatureComplete(borApplication) ? urls.contributionURL : urls.basicInformationURL;
  }
  if (!isIntuit() || borApplication === null) {
    return urls.basicInformationURL;
  }
  if (isCompanyInfoComplete(borApplication) && isInsuranceInfoComplete(borApplication) && isSignatureComplete(borApplication)) {
    return urls.contributionURL;
  }
  return urls.basicInformationURL;
};

export const getUrlFromBorApplication = (borApplication) => borApplication?.applicationStatus.nextSectionUrl || urls.landingPageURL;

export const isNextSectionUrlDone = (borApplication) => borApplication?.applicationStatus?.nextSectionUrl === `${urls.baseURL}${urls.doneURL}`;

const isCompanyInfoComplete = (borApplication) =>
  isValidString(borApplication.contactName) &&
  isValidString(borApplication.email) &&
  isValidString(borApplication.address1) &&
  isValidString(borApplication.zip) &&
  isValidString(borApplication.contactPhoneNumber);

const isInsuranceInfoComplete = (borApplication) =>
  isValidString(borApplication.borMedicalInsuranceCompany) && isValidString(borApplication.borMedicalGroupIDNumber);

const isSignatureComplete = (borApplication) => isValidString(borApplication.signatureImageDataUrl);

const isValidString = (str) => !!(str && str.length > 0);
